import { jsx as u } from "react/jsx-runtime";
import c from "react";
import { useFormAutoCompleteDispatch as h } from "./FormAutoCompleteProvider.js";
function _({ data: s, displayedKeys: r, field: a, isOpen: m, handleClose: i, query: l }) {
  const { dispatchAutoComplete: p } = h(), e = c.useMemo(() => l == null || l === "" ? null : s?.filter((o) => o[a].toLowerCase().includes(l.toLowerCase())), [s, a, l]), f = c.useMemo(() => r == null || r.length === 0 ? e : e?.map((o) => r.reduce((n, t) => (n[t] = o[t], n), {})), [r, e]);
  return /* @__PURE__ */ u(
    "ul",
    {
      className: "input-auto-complete-list",
      "data-is-open": m && e != null && e.length > 0,
      children: f?.map((o, n) => /* @__PURE__ */ u(
        "li",
        {
          className: "input-auto-complete-list__item",
          "data-is-open": m,
          children: /* @__PURE__ */ u(
            "button",
            {
              type: "button",
              onMouseDown: (t) => {
                t.preventDefault();
              },
              onClick: () => {
                p(e[n]), i();
              },
              children: Object.keys(o).map((t) => /* @__PURE__ */ u(
                "span",
                {
                  "data-emphasis": t === a,
                  children: o[t]
                },
                `${t}-${n}`
              ))
            }
          )
        },
        `${n}`
      ))
    }
  );
}
export {
  _ as default
};
